<template>
  <div class="main start">
    <div class="header center">
      <img src="@/assets/img/start-earth.png" alt="Earth" />
    </div>
    <div class="content">
      <div class="text ">
        <h1>The world needs a Hero!</h1>
        <p class="fontMono">
          A new deadly virus was detected and it is spreading worldwide at an
          alarming rate. <br /><br />
          If humanity won't stop it, we are all doomed! <br /><br />
          The world needs a billionaire hero to save it and develop vaccine as
          soon as possible.
        </p>
      </div>
      <router-link
        class="button"
        to="/game"
        @click="track('level_start', 'viruzz 01')"
        >Save the World!</router-link
      >
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/scss/index.scss";
.start {
  background: #000;
  color: #fff;
  display: flex;
  flex-direction: column;

  .content {
    margin: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // flex-grow: 1;
    .text {
      margin-bottom: 24px;
    }
  }
}
</style>
